import { request } from '@/common/utils/request'
import { cloneDeep } from 'lodash-es'
export function getMapShopList (params) { // 绩效考核方案指标项下发
  return request.post({
    url: 'feidian.bdapp.bizopp.map.getList',
    params
  }).then(res => res.data)
}

export function getMapFilter (params) { // 绩效考核方案指标项下发
  return request.get({
    url: 'feidian.bdapp.bizopp.map.getFilter',
    params
  }).then(res => res.data)
};
export function getMapFilterTags(params) { // 获取标签数据
  return request.get({
    url: 'feidian.bdapp.bizopp.getMapStrategyTag',
    params
  }).then(res => {
    if (res && res.data && res.data.strategyTag) {
      const tagResult = res.data.strategyTag
      const copyStrategyTag = cloneDeep(tagResult)
      copyStrategyTag.sort((a, b) => a.categoryId - b.categoryId)
      for (let category of copyStrategyTag) {
        category.tagId = `tags${category.categoryId}`
        const children = []
        for (let child of category.children) {
          const childObj = {}
          childObj.value = child.tagId
          childObj.label = child.tagName
          children.push(childObj)
        }
        category.children = children
      }
      const childrenArr = []
      for (const obj of copyStrategyTag) {
        childrenArr.push(...obj.children)
      }
      return copyStrategyTag
    }
  })
}
